import root from './root'
import auth from './auth'
import pages from './pages'
import posts from './posts'
import conversations from './conversations'

export default [
  root,
  auth,
  pages,
  posts,
  conversations
]